// src/components/DdosTesting/DdosTestingHeader.jsx
import React, { useState } from 'react';

// Accept onStartTest and isLoading as props
const DdosTestingHeader = () => {

  // Removed ipAddress state and handlers

  return (
    // Keep mb-8 for spacing before ServerInfoCard
    <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
      <div className="relative overflow-hidden bg-gradient-to-r from-dark-500 via-dark-600 to-dark-500 rounded-2xl p-6 md:p-8 border border-dark-400 hover:border-accent-red/30 transition-medium group">
        {/* Background effects specific to DDoS */}
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent-red opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>
        <div className="absolute -left-20 -bottom-20 w-56 h-56 bg-accent-purple opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>

         <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
          {/* Left side: Text */}
          <div className="w-full md:w-2/3 lg:w-1/2 mb-6 md:mb-0 text-center md:text-left">
            <div className="inline-flex items-center text-sm font-medium text-accent-red mb-2 animate-pulse-slow bg-accent-red/10 px-3 py-1 rounded-full">
              <i className="fas fa-radiation mr-2"></i>
              DDOS TESTING MODULE
            </div>
            <h2 className="text-3xl font-bold mb-3 group-hover:text-white transition-colors">
              Server Stress & Resilience
              <span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text bg-gradient-to-r from-accent-red to-accent-orange">Assessment</span>
            </h2>
            <p className="text-gray-400 text-sm max-w-md mx-auto md:mx-0 group-hover:text-gray-300 transition-colors">
              Analyze server resilience against common DDoS vectors. Connect to a target below to begin. Ensure authorization before proceeding.
            </p>
            {/* Input and Button Area REMOVED */}
          </div>

          {/* Right side: DDoS Themed Graphic */}
          <div className="w-full md:w-1/3 lg:w-1/2 md:pl-8 flex items-center justify-center mt-6 md:mt-0 opacity-60 md:opacity-100 group-hover:opacity-100 transition-opacity duration-300">
            <div className="relative w-48 h-48 group-hover:scale-105 transition-transform duration-500">
               <div className="absolute inset-0 border-4 border-accent-red/20 rounded-full animate-spin-slow"></div>
               <div className="absolute inset-2 border-2 border-accent-purple/20 rounded-full animate-spin-slow-reverse"></div>
               <div className="absolute inset-4 flex items-center justify-center text-center">
                  <i className="fas fa-shield-alt text-6xl text-accent-red opacity-40 animate-shield-pulse"></i>
               </div>
                {/* Floating particles */}
                {[...Array(5)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute w-2 h-2 bg-accent-red rounded-full animate-ping-slow"
                        style={{
                            top: `${Math.random() * 100}%`,
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 2}s`
                        }}
                    ></div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DdosTestingHeader;